import React, { useContext, useMemo } from 'react';
import useAdmins from '@ubeya/shared/hooks/account/useAdmins';
import { FlexMiddle } from '../../Flex';
import ConfigContext from '../../../contexts/ConfigContext';

const EventBookerChip = ({ value }) => {
  const { mappedAdmins } = useAdmins();
  const { t } = useContext(ConfigContext);

  const mappedAdminsWithNoEventBooker = useMemo(() => {
    return {
      ...mappedAdmins,
      [-1]: { firstName: t('noEventBooker') }
    };
  }, [mappedAdmins, t]);

  return (
    <FlexMiddle>
      {value
        .map((item) => {
          const admin = mappedAdminsWithNoEventBooker[item];
          if (!admin) return null;

          return [admin.firstName, admin.lastName].filter(Boolean).join(' ');
        })
        .filter(Boolean)
        .join(', ')}
    </FlexMiddle>
  );
};

export default EventBookerChip;
